import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";
import { Redirect, Route } from "wouter";
import { ReactNode } from "react";

interface ProtectedRouteProps {
  path: string;
  component: () => JSX.Element | null;
  requiresSubscription?: boolean;
}

export function ProtectedRoute({
  path,
  component: Component,
  requiresSubscription = false,
}: ProtectedRouteProps) {
  const { user, isLoading, isAuthenticated, isTrialExpired, hasActiveSubscription } = useAuth();

  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-border" />
        </div>
      </Route>
    );
  }

  if (!isAuthenticated) {
    return (
      <Route path={path}>
        <Redirect to="/auth" />
      </Route>
    );
  }

  if (requiresSubscription && isTrialExpired && !hasActiveSubscription) {
    return (
      <Route path={path}>
        <Redirect to="/subscribe" />
      </Route>
    );
  }

  return (
    <Route path={path}>
      <Component />
    </Route>
  );
}